module.exports = __webpack_public_path__ + "static/media/03-textpage-with-download.845a3f33.png";